export const branchValidation = ({
  name,
  address,
  state,
  city,
  postalCode,
  contactNumber
}) => {
  const errors = {};
  if (!name) {
    errors.name = "* Required";
  }

  if (!address) {
    errors.address = "* Required";
  }

  if (!state) {
    errors.state = "* Required";
  }

  if (!city) {
    errors.city = "* Required";
  }

  if (!postalCode) {
    errors.postalCode = "* Required";
  }

  if (!contactNumber) {
    errors.contactNumber = "* Required";
  } else if (contactNumber.replace(/[\s-]/g, "").length < 10) {
    errors.contactNumber = "* Invalid format";
  }

  return errors;
};
